import { useState } from "react";
import type { ProductMedia } from "@/lib/supabase";

interface ProductGalleryProps {
  images: ProductMedia[];
  title: string;
}

export default function ProductGallery({ images, title }: ProductGalleryProps) {
  const [activeIdx, setActiveIdx] = useState(0);

  const list = images.length > 0 ? images : [{ url: "", type: "image" }];
  const safeIdx = Math.min(activeIdx, list.length - 1);
  const active = list[safeIdx];

  const goPrev = () => setActiveIdx((i) => (i === 0 ? list.length - 1 : i - 1));
  const goNext = () => setActiveIdx((i) => (i + 1) % list.length);

  return (
    <div className="flex flex-col gap-4">
      {/* Main image */}
      <div className="relative aspect-square rounded-2xl overflow-hidden bg-background-100 group">
        {active.url ? (
          <img
            src={active.url}
            alt={title}
            className="w-full h-full object-cover object-top"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-foreground-500 text-sm">
            Sem imagem
          </div>
        )}

        {list.length > 1 && (
          <>
            <button
              type="button"
              onClick={goPrev}
              aria-label="Imagem anterior"
              className="absolute top-1/2 -translate-y-1/2 left-3 md:left-4 w-10 h-10 md:w-11 md:h-11 rounded-full bg-background-50/90 hover:bg-background-50 flex items-center justify-center text-foreground-950 transition-all cursor-pointer opacity-0 group-hover:opacity-100"
            >
              <i className="ri-arrow-left-s-line text-[20px]"></i>
            </button>
            <button
              type="button"
              onClick={goNext}
              aria-label="Próxima imagem"
              className="absolute top-1/2 -translate-y-1/2 right-3 md:right-4 w-10 h-10 md:w-11 md:h-11 rounded-full bg-background-50/90 hover:bg-background-50 flex items-center justify-center text-foreground-950 transition-all cursor-pointer opacity-0 group-hover:opacity-100"
            >
              <i className="ri-arrow-right-s-line text-[20px]"></i>
            </button>
          </>
        )}
      </div>

      {/* Dot indicators */}
      {list.length > 1 && (
        <div className="flex items-center justify-center gap-2">
          {list.map((_, i) => {
            const isActive = i === safeIdx;
            return (
              <button
                key={i}
                type="button"
                onClick={() => setActiveIdx(i)}
                aria-label={`Ver imagem ${i + 1}`}
                className={`rounded-full transition-all cursor-pointer ${
                  isActive
                    ? "w-6 h-2 bg-foreground-950"
                    : "w-2 h-2 bg-foreground-300 hover:bg-foreground-500"
                }`}
              ></button>
            );
          })}
        </div>
      )}
    </div>
  );
}